<template>
    <Fragment>
        <!-- TOGGLE EDITION MODE -->
        <button
            v-if="editActions"
            type="button"
            class="btn btn-dark ml-2 text-center"
            @click="configuration.isEditing = !configuration.isEditing"
        >
            <i v-show="!configuration.isEditing" class="fas fa-edit"></i>
            <i
                v-show="configuration.isEditing"
                @click="updateConfiguration()"
                class="fas fa-save"
            ></i>
        </button>

        <!-- DOWNLOAD EXCEL -->
        <button
            type="button"
            class="btn btn-dark m-2"
            v-if="selectionActions"
            @click="downloadExcel()"
        >
            <!-- {{ $t("popup_myconfigs_download_excel") }} -->
            <i title="Excel" class="fas fa-file-excel"></i>
        </button>

        <!-- DOWNLOAD PDF -->
        <button
            type="button"
            class="btn btn-dark m2"
            v-if="selectionActions"
            @click="downloadPdf()"
        >
            <!-- {{ $t("popup_myconfigs_download_pdf") }} -->
            <i title="PDF" class="fas fa-file-pdf"></i>
        </button>

        <!-- DELETE CONFIGURATION -->
        <button
            v-if="editActions"
            type="button"
            class="btn btn-dark ml-2 text-center"
            @click="deleteConfiguration()"
        >
            <i class="fas fa-trash-alt"></i>
        </button>

        <button
            v-if="closeAction"
            type="button"
            class="btn btn-dark m-2"
            data-bs-dismiss="modal"
            data-dismiss="modal"
        >
            {{ $t("popup_myconfigs_close") }}
        </button>
    </Fragment>
</template>

<script>
import { app } from "../../application.js";
import { Fragment } from "vue-fragment";
import jQuery from "jquery";

export default {
    name: 'configurationActionsComponent',
    props: {
        configuration: {},
        editActions: false,
        selectionActions: false,
        closeAction: false
    },

    components: {
        Fragment,
    },
    data() {
        return {
            app: app,
        }
    },
    watch: {
        configuration(newValue) {
            newValue.isEditing = false
        }
    },
    methods: {
        async updateConfiguration() {
            await this.app.API.saveConfig(this.configuration)
            await this.app.projects.refresh()
        },
        async deleteConfiguration() {
            let self = this;

            let infoModal = {
                modalToShow: "warnPageLeaveModal",
                title: this.app.translate("config_manag_delete_title"),
                message: this.app.translate("config_manag_delete_confirm"),
                html_message: "",
                showConfirmationButton: true,
                showCancelButton: true,
                textConfirmationButton: self.app.translate(
                    "default_text_acceptbutton"
                ),
                textCancelButton: self.app.translate(
                    "default_text_cancelbutton"
                ),
            };

            //ES6 object destructuring object resolved from promise:
            self.app
                .showModal(infoModal)
                .then(async ({ userAction, paramResult }) => {
                    if (userAction === "modal_rejected") {
                    } else if (userAction === "modal_confirmed") {
                        jQuery(".viewConfigurationModal").modal("hide");
                        await this.app.API.deleteConfig(this.configuration.id);
                        await this.app.projects.refresh()
                        // this.refresh();
                    }
                });
        },

        downloadExcel: async function () {
            await this.app.API.downloadById(
                "xlsx",
                this.configuration.id,
                this.configuration.label
            );
        },
        downloadPdf: async function () {
            await this.app.API.downloadById(
                "pdf",
                this.configuration.id,
                this.configuration.label
            );
        },
    }
}
</script>

<style>
</style>